
const styler = [ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ];
// Ultra Light with Labels by  https://snazzymaps.com/style/151/ultra-light-with-labels

document.addEventListener( 'DOMContentLoaded', function() {

    var elms = document.getElementsByClassName( 'map__map' );
	for ( var i = 0; i < elms.length; i++ ) {
        start_map();
    }
} );

function start_map() {

    /* Simple map */
    const elements = document.querySelectorAll( '.map__map' ); 
    
    var length = elements.length; 

    if (!length) {
        return;
    }

    while (length--) {
        var element = elements[ length ]; 

        var lat = parseFloat( element.getAttribute( 'data-lat' ) ); 
        var lng = parseFloat( element.getAttribute( 'data-lng' ) ); 
        var zoom = parseInt( element.getAttribute( 'data-zoom' ) );
        var icon = element.getAttribute( 'data-icon' );

        var map = new google.maps.Map( element, {
            // scrollwheel: false,
            center: { lat: lat, lng: lng },
            zoom: zoom,
            // disableDefaultUI: true,
            styles: styler,
            draggable: true
        } );
        

        // time out for marker
        var marker = new google.maps.Marker( {
            position: new google.maps.LatLng( lat, lng ),
            map: map,
            icon: {
                url: icon, scaledSize: new google.maps.Size(208, 148)
            },
            title: 'Click to zoom'
        } );
    }
};